import { MenuItemElement } from "./navigationTypes";

interface ReadableRef<T extends HTMLElement> {
    current: T | null;
}

export const focusElementOnNextFrame = (
    element: HTMLElement | null | undefined
): void => {
    requestAnimationFrame(() => {
        element?.focus();
    });
};

export const focusRefAfterRender = <T extends HTMLElement>(
    ref: ReadableRef<T>
): void => {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            ref.current?.focus();
        });
    });
};

export const focusFirstChild = (
    element: HTMLElement | null | undefined
): void => {
    element?.querySelector<HTMLElement>(":scope > *")?.focus();
};

export const getSecondLevelItemElement = (
    index: number | undefined
): MenuItemElement | null => {
    if (index === undefined || index < 0) {
        return null;
    }

    return document.querySelector<MenuItemElement>(
        `[data-second-level-index="${index}"]`
    );
};

export const getThirdLevelItemElement = (
    index: number | undefined
): MenuItemElement | null => {
    if (index === undefined || index < 0) {
        return null;
    }

    return document.querySelector<MenuItemElement>(
        `[data-third-level-index="${index}"]`
    );
};

export const focusSecondLevelItem = (
    index: number | undefined
): void => {
    focusFirstChild(getSecondLevelItemElement(index));
};

export const focusThirdLevelItem = (
    index: number | undefined
): void => {
    focusFirstChild(getThirdLevelItemElement(index));
};

export const focusFirstThirdLevelItem = (): void => {
    requestAnimationFrame(() => {
        focusThirdLevelItem(0);
    });
};

export const blurActiveElement = (): void => {
    if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur();
    }
};